import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

const style = require('./index.css');

export interface IGoogleDefaultProps {
  context: IAdFoxBannerContext;
}

export const GoogleDefaultBanner: React.StatelessComponent<IGoogleDefaultProps> = props => {
  return (
    <div className={style['bannerWrapper']}>
      <iframe
        width="728"
        height="90"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        frameBorder="0"
        src={props.context.code}
      />
    </div>
  );
};
